import { render, staticRenderFns } from "./User.vue?vue&type=template&id=1f885468&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
import style0 from "./User.vue?vue&type=style&index=0&id=1f885468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f885468",
  null
  
)

export default component.exports